import Dayjs from 'dayjs'
import { pageJump } from '@/global/location-transfer';
import router from '@/router'
import downloadFile1 from './download-file.js'

/**
 * 获取url上的query参数
 * @param {*} url
 * @returns
 */
function queryToJson(url) {
    if (!url) {
        url = window.location.href;
    }
    var query = url.substr(url.lastIndexOf('?') + 1),
        result = {},
        kv,
        key,
        value,
        item;
    if (query != url && query.indexOf('&') == -1) {
        query += '&';
    }
    query.split('&').forEach((param) => {
        if (param) {
            kv = param.split('=');
            key = kv[0];
            value = kv[1];
            item = result[key];
            if (typeof item === 'undefined') {
                result[key] = value;
            } else if (
                Object.prototype.toString.call(item) === '[object Array]'
            ) {
                item.push(value);
            } else {
                result[key] = [item, value];
            }
        }
    });
    return result;
}

const sizeFormat = function (value) {
    let fileSizeByte = value;
    let fileSizeMsg = '';
    if (fileSizeByte < 1048576) { fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + 'KB'; } else if (fileSizeByte == 1048576) fileSizeMsg = '1MB';
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) { fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + 'MB'; } else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) { fileSizeMsg = '1GB'; } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) { fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + 'GB'; } else fileSizeMsg = '1TB+';
    return fileSizeMsg;
}

/**
 * 深拷贝，如果只有一个参数，则默认第一个为数据源
 * @param {Object} target
 * @param {Object} source
 * @returns
 */
 function deepCopy(target, source) {
    if (arguments.length === 1) {
        source = arguments[0];
        target = Array.isArray(source) ? [] : {};
    }
    if (!target) {
        throw Error('Cannot convert undefined or null to object');
    }
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            target[keys] = deepCopy(source[keys])
        } else {
            target[keys] = source[keys]
        }
    })
    return target;
}

/**
 * 获取指定字符串的主域名，不传则为当前域名
 * @param {String} str 获取指定字符串的主域名，不传则为当前域名
 * @returns {String} 解析失败则返回空
 */
 function getDomainV2(str) {
    str = str || window.location.hostname;
    let arr = str.match(/([a-zA-Z\d][a-zA-Z\d\-]*?\.(?:[a-zA-Z\d]+)(?:\.(?:[a-zA-Z\d]))*)([\/|\?].*)?$/i) || [];
    return arr.length > 1 ? arr[1] : '';
}

// 判断当前日期是否处在本周内
function sameWeek(past) {
    const pastTime = new Date(past).getTime()
    const today = new Date(new Date().toLocaleDateString())
    let day = today.getDay()
    day = day == 0 ? 7 : day
    const oneDayTime = 60*60*24*1000
    const monday = new Date(today.getTime() - (oneDayTime * (day - 1)))
    const nextMonday = new Date(today.getTime() + (oneDayTime * (8 - day)))
    if(monday.getTime() <= pastTime && nextMonday.getTime() > pastTime) {
        return true
    } else {
        return false
    }
}
// 时分秒个位数的拼接0
function covertSingleDigit(num){
    return num >= 10 ? num : `0${num}`
}
/**
 * 
 * @param value - 格式化时间 时间格式化成多长时间之前
 * @param strict - true 是标准格式，false 是社区格式
 * @param specific - 是否返回具体时间，默认为false
 */

function dateFormat(value, strict, specific) {
    const dayDiff = Dayjs(Dayjs(value).format('YYYY/MM/D')).diff(
        Dayjs(Dayjs().format('YYYY/MM/D')),
        'day'
    );

    // 标准格式
    if (strict) {
        const timeString = Dayjs(value).format('HH:mm');
        switch (dayDiff) {
            case -1:
                return `昨天 ${timeString}`;
            case 0:
                return `今天 ${timeString}`;
            case 1:
                return `明天 ${timeString}`;
            default:
                {
                    const yearDiff = new Date(value).getFullYear() - Dayjs().year();
                    switch (yearDiff) {
                        case 0:
                            return `${Dayjs(value).format('MM月DD日')} ${timeString}`;
                        default:
                            return `${Dayjs(value).format(
                                'YYYY年MM月DD日'
                            )} ${timeString}`;
                    }
                }
        }
    }
    // 社区格式
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    let d = date.getDate();
    let curdate = new Date();
    let cy = curdate.getFullYear();
    var now = new Date().getTime();
    var diffValue = now - value;
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var dayC = diffValue / day;
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    var weekC = diffValue / week;
    let temp = '';
    if (cy > y) {
        temp = y + '.' + MM + '.' + d;
        return specific ? temp + ' ' + covertSingleDigit(date.getHours()) + ':' + covertSingleDigit(date.getMinutes()) : temp;
    } else if (!sameWeek(value)) {
        temp = MM + '.' + d;
        return specific ? temp + ' ' + covertSingleDigit(date.getHours()) + ':' + covertSingleDigit(date.getMinutes()) : temp;
    } else if (dayDiff < -1 && sameWeek(value)) {
        let weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        return weekArr[new Date(value).getDay()] + ' ' + covertSingleDigit(date.getHours()) + ':' + covertSingleDigit(date.getMinutes());
    } else if (dayDiff == -1) {
        return specific ? '昨天' + ' ' + covertSingleDigit(date.getHours()) + ':' + covertSingleDigit(date.getMinutes()) : '昨天';
    } else {
        return covertSingleDigit(date.getHours()) + ':' + covertSingleDigit(date.getMinutes());
    }
    /* else if (hourC >= 1) {
        return '' + parseInt(hourC) + '小时前';
    } else if (minC >= 5) {
        return '' + parseInt(minC) + '分钟前';
    } else {
        return '刚刚';
    } */
    

}

/**
 * 跳转新闻咨询、公告、banner详情页
 * @param {Object} info 新闻信息
 */
function goNewsDetail (info, routeName) {
    if (info.contentForm === 1) { // 新闻内容是链接
        window.open(info.clickUrl);
        return;
    }
    if ((info.contentForm == 0 && routeName === 'bannerDetail') || !info.contentId) { // banner 无链接 或者contentId不存在
        return;
    }
    pageJump({name: routeName, query: { id: info.contentId }}, true);
}

// 获取点击的跳转链接
function getLink(info, routeName){
    if (info.contentForm === 1) { // 新闻内容是链接
        return {
            url: info.clickUrl,
            className: 'link-style'
        };
    }
    let path = router.resolve({name: routeName}).path;
    return {
        url: `${path}?id=${info.contentId}`,
        className: 'link-style'
    }
}
/** 防抖
 * 它返回一个函数，只要它继续被调用，就不会被触发。该函数将在停止调用 N 毫秒后被调用。如果传递了`immediate`，则在前沿触发函数，而不是尾随
 * @param func - 要执行的功能
 * @param wait - 要延迟的毫秒数。
 * @param immediate - 如果为真，则在前沿触发函数，而不是在尾部触发。
 * @returns 在一定时间后调用传入的函数的函数。
 */
function Debounce(func, wait, immediate) {
    let timeout
    wait = wait || 500
    immediate = immediate || true

    return function() {
        const context = this
        const args = arguments

        if (timeout) {
            clearTimeout(timeout);
        }
        if (immediate) {
            var callNow = !timeout
            timeout = setTimeout(() => {
                timeout = null
            }, wait)
            if (callNow) {
                func.apply(context, args);
            }
        } else {
            timeout = setTimeout(function() {
                func.apply(context, args)
            }, wait)
        }
    }
}

/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
function Throttle(fn, t) {
    let last
    let timer
    const interval = t || 500
    return function() {
        const args = arguments
        const now = +new Date()
        if (last && now - last < interval) {
        clearTimeout(timer)
        timer = setTimeout(() => {
            last = now
            // console.log("实际执行函数（" + interval + "）：" + typeof fn)
            fn.apply(this, args)
        }, interval)
        } else {
        last = now
        // console.log("实际执行函数（" + interval + "）：" + typeof fn)
        fn.apply(this, args)
        }
    }
}
function formatTime(time, format = 'YYYY-MM-DD HH:mm'){
    if (!time) {
        return '-'
    }
    return Dayjs(time).format(format)
}
/* 部分隐藏处理
** str 需要处理的字符串
** frontLen 保留的前几位
** endLen 保留的后几位
** cha 替换的字符串
*/
function plusXing(str, frontLen, endLen, cha) {
    let len = str.length - frontLen - endLen;
    let xing = '';
    for (let i = 0; i < len; i++) {
        xing += cha;
    }
    return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
    )
}

// ie浏览器判断方法
function IEVersion() {
    var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    var isIE =
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; // 判断是否IE<11浏览器
    var isEdge = userAgent.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
    var isIE11 =
        userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
    if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        reIE.test(userAgent);
        // eslint-disable-next-line dot-notation
        var fIEVersion = parseFloat(RegExp['$1']);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6; // IE版本<=7
        }
    } else if (isEdge) {
        return 'edge'; // edge
    } else if (isIE11) {
        return 11; // IE11
    } else {
        return -1; // 不是ie浏览器
    }
}
/**
 * 方法：检测密码强弱
 * @param {String} 密码字段的值
 * @param {Object} 返回密码强度及对应提示信息
 * 返回值： 1 || 2 || 3    分别对应  （弱 || 中 || 强） 0为不符合要求
*/
const checkPassStrong = function (sValue) {

    if(!sValue) {
        return {code: 0, msg: '密码不能为空'};
    }

    // 长度不符合
    if(sValue.length < 8 || sValue.length > 16) {
        return {code: 0, msg: '密码长度不符合要求'};
    }

    // 全是数字
    if((/^\d+$/).test(sValue)) {
        return {code: 1, msg: '密码等级低，请修改'};
    }

    // 全是字母
    if((/^[A-Za-z]+$/).test(sValue)) {
        return {code: 1, msg: '密码等级低，请修改'};
    }

    // 全是特殊符号
    if((/^[\W_]+$/).test(sValue)) {
        return {code: 1, msg: '密码等级低，请修改'};
    }
    // 数字、字母、特殊符号都有
    if(/\d/.test(sValue) && /[A-Z]/.test(sValue) && /[\W_]/.test(sValue) && /[a-z]/.test(sValue)) {
        return {code: 3, msg: '密码符合要求'};
    }
    // if(/[A-Z]/.test(sValue) && /[\W_]/.test(sValue) && /[a-z]/.test(sValue)) {
    //     return {code: 2, msg: '密码符合要求'}
    // }
    if(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,16}$/.test(sValue)) {
        return {code: 2, msg: '密码符合要求'}
    }
    
    // if(/^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z|a-z])(?=.*[^A-z0-9]).*$/.test(sValue)) {
    //     return {code: 2, msg: '密码符合要求'}
    // }
    return {code: 1, msg: '密码等级低，请修改'};
}

// 协作组动态时间
function dealDynamicTime(params) {
    const dayDiff = Dayjs(Dayjs(params).format('YYYY/MM/D')).diff(
        Dayjs(Dayjs().format('YYYY/MM/D')),
        'day'
    );
    const curWeekTime = [
        new Date(Dayjs().startOf('week').add(1, 'day')).getTime(),
        new Date(Dayjs().endOf('week').add(1, 'day')).getTime()
    ]
    let str = '';
    switch (dayDiff) {
        case -1:
            str = `昨天 ${Dayjs(params).format('HH:mm')}`;
            break;
        case 0:
            str = `${Dayjs(params).format('HH:mm')}`;
            break;
        default: {
            if (curWeekTime[1] >= params && params >= curWeekTime[0]) {
                let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                str = `${weekArr[new Date(params).getDay()]} ${Dayjs(params).format('HH:mm')}`;
                break;
            } else if ( Number(Dayjs(params).format('YYYY')) == new Date().getFullYear() ) {
                str = `${Dayjs(params).format('MM.DD HH:mm')}`;
                break;
            } else {
                str = `${Dayjs(params).format('YYYY.MM.DD HH:mm')}`;
                break;
            }
        }
    }
    return str;
}

// 返回当前时间段
function timeTips() {
    let hour = new Date().getHours();
    return (hour <= 6 && '凌晨好！') || (hour < 12 && '上午好！') || (hour <= 14 && '中午好！') || (hour <= 19 && '下午好') || '晚上好！'
}

// 处理学段学科数据
const handleStageSubject = (dataList, nodata = '') => {
    let stageList = dataList || [];
    let str = '';
    stageList.forEach((stageItem) => {
        let subjects = (stageItem.subjectList || [])
            .map((item) => {
                return item.subjectName;
            })
            .join('，');

        str += subjects ? `${stageItem.stageName}：${subjects}` + '；' : `${stageItem.stageName}` + '；';
    });
    str = str.substring(0, str.length - 1);
    return str || nodata;
}
// 处理学段数据
const handleStage = (dataList, nodata = '') => {
    let stageList = dataList || [];
    let str = '';
    str = stageList.map((item) => {
        return item.stageName;
    })
    .join('、');
    return str || nodata;
}
// 处理学科数据
const handleSubject = (dataList, nodata = '') => {
    let stageList = dataList || [];
    let str = '';
    stageList.forEach((stageItem, index) => {
        let subjects = stageItem.subjectList
            .map((item) => {
                return item.subjectName;
            })
            .join('，');
        str += (index?('、'+subjects):subjects);
    });
    return str || nodata;
}
// 处理学段数据
const handleGrade = (dataList, nodata = '') => {
    let gradeList = dataList || [];
    let str = '';
    str = gradeList.map((item) => {
        return item.gradeName;
    })
    .join('、');
    return str || nodata;
}
// 处理分类数据
function handleClassify (dataList, nodata = '') {
    let classifyList = dataList || [];
    let str = '';
    if (classifyList.length) {
        treeForEach(classifyList, (item) => {
            str = str ? str + '>' + item.name : str + item.name
        })
    }
    return str || nodata;
}

// 遍历树节点
function treeForEach(list, func) {
    let tree = list || [];
    tree.forEach(data => {
        func(data)
        data.children && treeForEach(data.children, func) // 遍历子树
    
    })
}

// 增加行内样式表
function addInlineStylesheet(cssText) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(cssText));
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(style);
}
class PollTask {

    /**
     * @param {string} timer 要存储时变量前缀
     * @param {string} abortState 存储类型是 cookie|localStorage|sessionStorage
     */
    constructor(timer, abortState) {
        this.timer = null;
        this.abortState = abortState;
    }

    async startPoll(fn, validate, interval = 1000) {
        const resolver = async (resolve, reject) => {
          if(this.timer) {
              clearTimeout(this.timer)
          }
          try { // catch any error thrown by the "fn" function
            const result = await fn(); // fn does not need to be asynchronous or return promise
            // call validator to see if the data is at the state to stop the polling
            const valid = validate(result);
            console.log(valid);
            if (valid === true || this.abortState) {
               resolve(result);
            } else if (valid === false) {
               this.timer = setTimeout(resolver, interval, resolve, reject);
            } // if validator returns anything other than "true" or "false" it stops polling
          } catch (e) {
              clearTimeout(this.timer)
              reject(e);
          }
        };
        return new Promise(resolver);
    }

    abortPoll() {
        clearTimeout(this.timer);
        this.timer = null;
        this.abortState = true; 
    }
}

// async function startPoll(fn, validate, interval = 1000) {
//     const resolver = async (resolve, reject) => {
//       let timer = null;
//       try { // catch any error thrown by the "fn" function
//         const result = await fn(); // fn does not need to be asynchronous or return promise
//         // call validator to see if the data is at the state to stop the polling
//         const valid = validate(result);
//         console.log(valid);
//         if (valid === true) {
//            resolve(result);
//         } else if (valid === false) {
//            timer = setTimeout(resolver, interval, resolve, reject);
//         } // if validator returns anything other than "true" or "false" it stops polling
//       } catch (e) {
//           clearTimeout(timer)
//           reject(e);
//       }
//     };
//     return new Promise(resolver);
// }

function getTargetUrl (props) {
    if(props.linkUrl) {
        return props.linkUrl;
    }
    let url = window.location.origin + '/idx/userCenter/userHomePage?uId=' + props.userId;
    return url
}

const getImgDownloadUrl = function (materialVo) {
    if(['oss'].includes(materialVo && materialVo.ispType)) {
        window.location.href = `${materialVo.materialUrl}?response-content-type=application/octet-stream`;
    } else if(['tos'].includes(materialVo && materialVo.ispType)) {
        let fileName = encodeURIComponent(`attachment;filename=${materialVo.materialFullName}`)
        window.location.href = `${materialVo.materialUrl}?response-content-disposition=${fileName}`;
    } else if(['ctYun'].includes(materialVo && materialVo.ispType)) {
        downloadFile1(materialVo.materialUrl, materialVo.materialFullName)
    } else {
        window.location.href = `${materialVo.materialUrl}?attname=${materialVo.materialFullName}`;
    }
}


function getFileUrl(data){
    if(data.host && data.host.slice(-1) === '/') {
        return `${data.host}${data.url}`;
    }
    return `${data.host}/${data.url}`;
}


// 获取url 某个参数的值
function getQueryString(url, paraName) {
    let arrObj = url.split('?');
    if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&');
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=');
            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return '';
    } else {
        return '';
    }
}

// 清空已经换过的ticket信息
function clearTicket () {
    let queryStr = queryToJson(window.location.href);
    let newSearch = '?';
    for (let key in queryStr) {
        if (key !== 'ticket' && key !== 'keepCookie') {
            newSearch = newSearch + key + '=' + queryStr[key] + '&'
        }
    }
    newSearch = newSearch.slice(0, -1);
    setTimeout(() => { // 延时是因为立即执行不生效
        if (newSearch) { // 有参数修改参数
            window.history.replaceState('', '', newSearch);
        } else { // 没有参数修改路由
            window.history.replaceState('', '', window.location.pathname);
        }
    }, 500)
}

function formatDateToMin(time) {
    if(!time) {
        return '';
    }
    return time && Dayjs(time).format('YYYY-MM-DD HH:mm') || '';
}

function checkIsSuperBrand() {
    const host = location.host;
    return host.includes('super-brand')
}

// 页面跳转传参url防止xss攻击
// <	&#x3c;
// >	&#x3e;
// "	&#x22;
// '	&#x27;
// script 空字符串
function xssQueryUrl (url) {
    let newUrl = url || '';
    let regex1 = new RegExp('script', "gi");
    let result1 = newUrl.replace(regex1, '');

    let regex2 = new RegExp('>', "g");
    let result2 = result1.replace(regex2, '&#x3e');

    let regex3 = new RegExp('"', "g");
    let result3 = result2.replace(regex3, '&#x22');

    let regex4 = new RegExp("'", "g");
    let result4 = result3.replace(regex4, '&#x27');

    let regex5 = new RegExp('<', "g");
    let result5 = result4.replace(regex5, '&#x3c');

    return result5;
}

/**
 * @param moduleKey 模块key
 * @param list 导航列表
 * @param route 当前路由
 * @returns {T|*|null|{link}}
 */
function findNavigationItem(moduleKey, list, route) {
    // 1. 首先检查是否有直接匹配moduleKey的一级导航
    const directMatch = list.find(item => item.moduleKey === moduleKey);
    if (directMatch) {
        return directMatch; // 返回一级导航
    }

    // 2. 检查子导航是否有匹配的（二级导航）
    for (const item of list) {
        if (item.sub_navs && item.sub_navs.length) {
            const matchedSubNav = item.sub_navs.find(sub => {
                // 子导航没有moduleKey但有link的情况
                if (!sub.moduleKey && sub.link) {
                    const path = sub.link.replace(/^https?:\/\/[^\/]+/, '').split('?')[0];
                    return path === route.path;
                }
                return sub.moduleKey === moduleKey;
            });

            if (matchedSubNav) {
                return matchedSubNav;
            }
        }
    }

    // 3. 检查顶级导航是否有匹配的link（一级导航）
    for (const item of list) {
        if (!item.moduleKey && item.link) {
            const path = item.link.replace(/^https?:\/\/[^\/]+/, '').split('?')[0];
            if (path === route.path) {
                return item;
            }
        }
        if(item.moduleKey === moduleKey) {
            return item;
        }
    }

    // 如果没有找到任何匹配项，返回null
    return null;
}
function getEnvSuffix() {
    const env = process.env.VUE_APP_MODE;
    return {
        local: '-dev',
        dev: '-dev',
        qa: '-qa',
        production: '',
    }[env];
}


/**
 * 多层级合并对象
 * @param target 目标对象
 * @param source 合并对象
 * @returns 合并后对象
 */
function assignRecursive(target, source) {
    if (typeof target !== 'object' || typeof source !== 'object') return source;
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = assignRecursive(target[key], source[key]);
        } else {
            target[key] = source[key];
        }
    }
    return target;
}


export {
    checkIsSuperBrand,
    getLink,
    formatTime,
    Debounce,
    Throttle,
    dateFormat,
    queryToJson,
    deepCopy,
    getDomainV2,
    goNewsDetail,
    plusXing,
    IEVersion,
    checkPassStrong,
    dealDynamicTime,
    timeTips,
    handleStageSubject,
    PollTask,
    handleClassify,
    handleGrade,
    handleSubject,
    handleStage,
    getTargetUrl,
    getImgDownloadUrl,
    getQueryString,
    clearTicket,
    addInlineStylesheet,
    getFileUrl,
    sizeFormat,
    formatDateToMin,
    xssQueryUrl,
    findNavigationItem,
    getEnvSuffix,
    assignRecursive,
};
